import RecipeInformation from './RecipeInformation';

export default RecipeInformation;
